//View and edit page for issue ticket

import React, { useState, useEffect, ChangeEvent } from 'react';
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  MenuItem,
  Select,
  SelectChangeEvent,
  ThemeProvider,
} from '@mui/material';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import BasicTable, { Column } from '../../../components/table';
import getTheme from '../../../theme/theme';
import { BASEURL, ARROW, IMAGEURL } from '../../../constants/Common';
import FloatingButton from './FloatingButton';

interface EditedLog {
  issue_id: number | null;
  issue_status: string;
  created_date: string;
  issue_comments: string;
  issue_category: string;
  issue_description: string;
  attachments: File | null;
  attachments2: File | null;
  attachments3: File | null;
  attachments4: File | null;
  attachments5: File | null;
  attachments6: File | null;
}

interface ProgressUpdate {
  id: number;
  created_date: string;
  issue_from: string;
  issue_to: string;
  issue_comments: string;
  issue_org_id: number;
  issue_tracking_id: number;
  trackingid: number;
  attachments: string | null;
  attachments2: string | null;
  attachments3: string | null;
  attachments4: string | null;
  attachments5: string | null;
  attachments6: string | null;
}

const IssueLogEdit = () => {
  // const theme = useTheme();
  const navigate = useNavigate();
  const [isEditMode, setIsEditMode] = useState(false);
  const [editedLog, setEditedLog] = useState<EditedLog | null>(null);
  const [progressUpdates, setProgressUpdates] = useState<ProgressUpdate[]>([]);
  const [selectedLog, setSelectedLog] = useState<EditedLog | null>(null);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [ticketDetails, setTicketDetails] = useState<ProgressUpdate[]>([]);
  const [emailuser, setEmailUser] = useState({ user: { email: '' } });
  const [isSaving, setIsSaving] = useState(false);



  const fromusername = (localStorage.getItem('username') || '');
  const storedAuthData = localStorage.getItem('authData');
  const user_id = storedAuthData ? parseInt(storedAuthData, 10) : null;

  const storedAdmindata = localStorage.getItem('userRoleAdmin');
  let Userrole: any = null;
  if (storedAdmindata) {
    Userrole = JSON.parse(storedAdmindata);
  } else {
    console.log('No data found in localStorage');

  }
  const organizationId1 = localStorage.getItem('orgid');
  let organizationId: any = null;

  if (organizationId1) {
    organizationId = JSON.parse(organizationId1);
  } else {
    navigate('/login')
  }

  const sendemail = localStorage.getItem('email');
  let email: any = null;

  if (sendemail) {
    email = JSON.parse(sendemail);
  } else {
    navigate('/login')
  }

  const ticketid = JSON.parse(localStorage.getItem('selectedIdforTicket') || 'null');


  //fetch issue tracking details
  useEffect(() => {
    const fetchIssueUpdates = async () => {
      try {
        const response = await axios.get(BASEURL + '/ticketissues/', {
          headers: { Accept: 'application/json' },
        });
        setProgressUpdates(response.data);
        // console.log("response.dataissue:", response.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchIssueUpdates();
  }, []);

  useEffect(() => {
    const fetchIssueUpdates = async () => {
      try {
        const response = await axios.get(BASEURL + `/issues-org/${organizationId}/`, {
          headers: { Accept: 'application/json' },
        });
        setTicketDetails(response.data.tracking_issues);
        // console.log("response.orgticket:",response.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchIssueUpdates();
  }, []);

  //fetch ticket issue using id

  useEffect(() => {
    const fetchSelectedIssue = async () => {
      try {
        const response = await axios.get(BASEURL + `/issues/${ticketid}`, {
          headers: { Accept: 'application/json' },
        });
        // console.log("response.data:",response.data);
        setSelectedLog(response.data);
        setEditedLog(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchSelectedIssue();
  }, [ticketid]);


  //user-email fetch

  useEffect(() => {
    const fetchUserEmail = async () => {
      try {
        const response = await axios.get(BASEURL + `/issue_user_detail/${ticketid}`, {
          headers: { Accept: 'application/json' },
        });
        // console.log("response.data:", response.data);
        setEmailUser(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchUserEmail();
  }, [ticketid]);

  const issue_id = selectedLog?.issue_id



  const columns: Column[] = [
    { id: 'from', label: 'From', align: 'left' },
    { id: 'to', label: 'To', align: 'left' },
    { id: 'comments', label: 'Comments', align: 'left' },
    { id: 'createdon', label: 'Created On', align: 'left' },
    { id: 'attachments', label: 'Attachments', align: 'left' },
  ];

  const handleEditClick = () => {
    setEditedLog((prevState) => ({
      ...prevState!,
      issue_comments: '',
      attachments: null,
      attachments2: null,
      attachments3: null,
      attachments4: null,
      attachments5: null,
      attachments6: null,
    }));
    setIsEditMode(true);
  };


  const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target;
    setEditedLog((prev) => ({
      ...prev!,
      [name]: value,
    }));
  };

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    const { name, value } = event.target;
    setEditedLog((prev) => ({
      ...prev!,
      [name]: value,
    }));
  };

  const handleFilesChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newFiles = Array.from(event.target.files!);

    if (newFiles.length + selectedFiles.length > 6) {
      toast.error('You can only upload up to 6 files.');
      return;
    }

    setSelectedFiles((prev) => [...prev, ...newFiles]);
  };

  const handleButtonClick = (evt: any) => {
    evt.preventDefault();
    document.getElementById('fileInput')?.click();
  };

  const handleRemoveFile = (fileName: string) => {
    setSelectedFiles((prev) => prev.filter((file) => file.name !== fileName));
  };

  const downloadImage = async (imageUrl : string) => {
    const imageUrlPath = BASEURL + '/download_image' ;

    if (imageUrl) {
      try {
        // Fetch the image blob using the imageUrl from the metadata
   //     const response = await axios.get(imageUrlPath, {
        const response = await axios.get(`${imageUrlPath}?image_name=${encodeURIComponent(imageUrl)}`, {
            responseType: 'blob',
        });

        // Create a URL for the blob object
        const blob = new Blob([response.data], { type: 'image/jpeg' });
        const downloadUrl = window.URL.createObjectURL(blob);

        const fileName = imageUrl.substring(imageUrl.lastIndexOf('/') + 1);

        // Create an anchor element and trigger a download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName); // You can also dynamically set the filename here
        document.body.appendChild(link);
        link.click();
        link.remove();  // Clean up by removing the link
      } catch (error) {
        console.error('Failed to download the image:', error);
      }
    }
  };




  const getAttachmentsUrl = (attachmentUrl: string | null) => {
    return attachmentUrl ? (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault(); // Prevent default link behavior
          downloadImage(attachmentUrl); // Call the downloadImage function
        }}
      >
        {attachmentUrl.split('/').pop()} {/* Display file name */}
      </a>
    ) : '';
  };




  

  const renderAttachment = (progress: any) => {
    const attachments = [
      getAttachmentsUrl(progress.attachments),
      getAttachmentsUrl(progress.attachments2),
      getAttachmentsUrl(progress.attachments3),
      getAttachmentsUrl(progress.attachments4),
      getAttachmentsUrl(progress.attachments5),
      getAttachmentsUrl(progress.attachments6),
    ].filter(Boolean);

    return attachments.map((attachment, index) => (
      <React.Fragment key={index}>
        {attachment}
        {index < attachments.length - 1 && <br />}
      </React.Fragment>
    ));
  };


  const rows = (Userrole === 'Support' ? progressUpdates : ticketDetails)
    .filter((progress) =>
      Userrole === 'Support'
        ? progress.issue_tracking_id === ticketid
        : progress.issue_tracking_id === ticketid // For non-support roles, only check issue_tracking_id
    )
    .map((progress) => ({
      from: progress.issue_from,
      to: progress.issue_to,
      createdon: progress.created_date ? progress.created_date.split('T')[0] : '',
      comments: progress.issue_comments,
      attachments: renderAttachment(progress),
    }))
    .reverse();

  const fromValues = rows.map(row => row.from);
  console.log(fromValues[0]);

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  console.log(getCurrentDate()); // Outputs the current date in YYYY-MM-DD format


  const handleSaveClick = async () => {
    if (!editedLog) return;
    setIsSaving(true);

    try {
      const editTicketData = {
        issue_from: fromusername,
        issue_to: fromusername === "support" ? fromValues[0] : "support",
        resolved_date: fromusername === "support" ? getCurrentDate() : null,
        issue_comments: editedLog.issue_comments,
        issue_status: editedLog.issue_status,
        issue_tracking_id: ticketid,
        user_id :user_id ,
        issue_org_id: organizationId,
        email: fromusername === "support" && emailuser?.user ? emailuser.user.email : email,
        attachments: selectedFiles[0] || null,
        attachments2: selectedFiles[1] || null,
        attachments3: selectedFiles[2] || null,
        attachments4: selectedFiles[3] || null,
        attachments5: selectedFiles[4] || null,
        attachments6: selectedFiles[5] || null,
      };

      const response = await axios.post(BASEURL + '/trackingissues/', editTicketData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      setProgressUpdates((prev) => [...prev, response.data]);
      setTicketDetails((prev) => [...prev, response.data]);
      setSelectedLog((prev) => ({ ...prev!, ...editedLog }));
      setEditedLog((prev) => ({ ...prev!, ...editedLog }));

      setSelectedFiles([]);
      toast.success('Ticket edited successfully');
      setIsSaving(false);
      setIsEditMode(false);
    } catch (error) {
      toast.error('Error saving');
      setIsSaving(false);
    }
  };


  const statusOptions = ['Active', 'Closed'];

  return (
    <ThemeProvider theme={getTheme()}>
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: '-70px' }}>
          {!isEditMode ? (
            <Typography variant='h6' gutterBottom>

              <Link to='/usersupporthome'>User Support</Link> {ARROW} <Link to='/ticket'>Helpdesk</Link> {ARROW} View Ticket
            </Typography>
          ) : (
            <Typography variant='h6' gutterBottom>
              <Link to='/usersupporthome'>User Support</Link> {ARROW} <Link to='/ticket'>Helpdesk</Link> {ARROW} Edit Ticket
            </Typography>)}

          {!isEditMode ? (
            <Button variant='contained' color='primary' onClick={handleEditClick}>
              Reopen
            </Button>
          ) : (
            <Button variant='contained' color='primary' onClick={handleSaveClick}
              sx={{ '&:disabled': { bgcolor: 'grey.400', color: 'grey.700' } }} disabled={isSaving}>
              Save
            </Button>
          )}
        </Box>
        {selectedLog ? (
          <Box>
            <Grid container spacing={2} sx={{ mt: '30px' }}>
              <Grid item xs={3} sx={{ ml: '30px' }}>
                <strong>Feedback Id</strong>
              </Grid>
              <Grid item xs={3} sx={{ ml: '-30px' }}>
                {isEditMode ? (
                  // <TextField variant='outlined' value={editedLog?.issue_id || ''} fullWidth InputProps={{ readOnly: true }} />
                  <Box >{selectedLog.issue_id}</Box>
                ) : (
                  <Box >{selectedLog.issue_id}</Box>
                )}
              </Grid>
              <Grid item xs={3} sx={{ ml: '30px' }}>
                <strong>Status</strong>
              </Grid>
              <Grid item xs={3} sx={{ ml: '-30px' }}>
                {isEditMode ? (
                  <Select
                    name='issue_status'
                    value={editedLog?.issue_status}
                    onChange={handleSelectChange}
                    displayEmpty
                    fullWidth
                    variant='outlined'
                  >
                    {statusOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                ) : (
                  <Box >{selectedLog.issue_status}</Box>
                )}
              </Grid>
              <Grid item xs={3} sx={{ ml: '30px' }}>
                <strong>Category</strong>
              </Grid>
              <Grid item xs={3} sx={{ ml: '-30px' }}>
                {isEditMode ? (
                  // <TextField
                  //   name='issue_category'
                  //   variant='outlined'
                  //   value={editedLog?.issue_category}
                  //   onChange={handleChange}
                  //   fullWidth
                  //   InputProps={{ readOnly: true }}
                  // />
                  <Box >{selectedLog.issue_category}</Box>
                ) : (
                  <Box >{selectedLog.issue_category}</Box>
                )}
              </Grid>
              <Grid item xs={3} sx={{ ml: '30px' }}>
                <strong>Comments</strong>
              </Grid>
              <Grid item xs={3} sx={{ ml: '-30px' }}>
                {isEditMode ? (
                  <TextField
                    name='issue_comments'
                    variant='outlined'
                    value={editedLog?.issue_comments}
                    onChange={handleChange}
                    fullWidth
                    multiline
                    rows={3}
                  />
                ) : (
                  <Box >{selectedLog.issue_comments}</Box>
                )}
              </Grid>
              <Grid item xs={3} sx={{ ml: '30px' }}>
                <strong>Description</strong>
              </Grid>
              <Grid item xs={3} sx={{ ml: '-30px' }}>
                {isEditMode ? (
                  // <TextField
                  //   name='issue_description'
                  //   variant='outlined'
                  //   value={editedLog?.issue_description}
                  //   onChange={handleChange}
                  //   fullWidth
                  //   InputProps={{ readOnly: true }}
                  // />
                  <Box >{selectedLog.issue_description}</Box>
                ) : (
                  <Box >{selectedLog.issue_description}</Box>
                )}
              </Grid>
              {isEditMode && (
                <>
                  <Grid item xs={3} sx={{ ml: '30px' }}>
                    <strong>Attachments</strong>
                  </Grid>
                  <Grid item xs={3} sx={{ ml: '-30px' }}>
                    <Button variant='contained' color='primary' onClick={handleButtonClick}>
                      Browse
                    </Button>
                    <input
                      id='fileInput'
                      type='file'
                      style={{ display: 'none' }}
                      onChange={handleFilesChange}
                      multiple
                    />
                    {selectedFiles.map((file, index) => (
                      <Box key={index}>
                        {file.name}
                        <Button onClick={() => handleRemoveFile(file.name)}
                          color='error'
                          variant='text'>Remove</Button>
                      </Box>
                    ))}
                  </Grid>
                </>
              )}
            </Grid>

            <h3 style={{ marginTop: '140px' }}>Ticket History</h3>

            <BasicTable columns={columns} rows={rows} />
          </Box>
        ) : (
          <Typography>Loading...</Typography>
        )}
        <FloatingButton />
      </Box>
    </ThemeProvider>
  );
};

export default IssueLogEdit;